import {getReportById,getReports,downloadReportById} from '../api/report';

import {getErrors} from '../utils/tools';

export function getReportByIdAction(id,reports,force) {
  return(dispatch)=>{
    /*/!* Vérifie is l'report existe dans le state *!/
    let exist = false
    for (var i in reports) {
      if(parseInt(id, 10) === parseInt(reports[i].id, 10) && !force) {
        exist = true
        dispatch({
            type:"UPDATE_REPORT",
            report:reports[i]
        });
        return Promise.resolve("ok");
      }
    }*/

    //if (!exist){
      return this.loggedIn().then((res) => { // Vérifie l'authentification
        const token = localStorage.getItem("id_token")
        return getReportById(token,id)
          .then(res => {
            dispatch({
                type:"UPDATE_REPORT",
                report:res
            });
          })
          .catch((err)=>{
            let errors = getErrors(err)
            this.displaySnackbar("error", errors[0].message);
            throw err
          })
      })
    //}
  }
}

export function downloadReportByIdAction(id, report, filename) {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return downloadReportById(token, id, filename)
        .then(res => {
          this.displaySnackbar("success", "Rapport géneré");
          return res
        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })
    })
  }
}

export function getReportsAction() {
  return(dispatch)=>{
    return this.loggedIn().then((res) => { // Vérifie l'authentification
      const token = localStorage.getItem("id_token")
      return getReports(token)
        .then(res => {
          dispatch({
              type:"UPDATE_REPORTS",
              reports:res
          });
        })
        .catch((err)=>{
          let errors = getErrors(err)
          this.displaySnackbar("error", errors[0].message);
          throw err
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/report.js